var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCondenserOffHeaterOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Condenser_OFF_Heater_OFF",
    "data-name": "Condenser OFF_Heater OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 33,
    viewBox: "0 0 91 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M90.35,16.51H86.6V4.59A3.941,3.941,0,0,0,82.66.65H9.27A3.935,3.935,0,0,0,5.33,4.59V16.52H.65v9.21H5.33v2.69a3.941,3.941,0,0,0,3.94,3.94H82.66a3.935,3.935,0,0,0,3.94-3.94V25.73h3.75V16.51Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M82.66,33H9.27a4.6,4.6,0,0,1-4.59-4.59V26.37H0V15.86H4.68V4.59A4.6,4.6,0,0,1,9.27,0H82.66a4.6,4.6,0,0,1,4.59,4.59V15.87H91V26.38H87.25v2.04A4.594,4.594,0,0,1,82.66,33ZM1.3,25.08H5.98v3.34a3.3,3.3,0,0,0,3.3,3.29H82.67a3.3,3.3,0,0,0,3.3-3.29V25.08h3.75V17.16H85.97V4.59a3.3,3.3,0,0,0-3.3-3.29H9.27a3.3,3.3,0,0,0-3.3,3.29V17.16H1.3Z",
    fill: "#6a7084"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9826",
    "data-name": "Group 9826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M26.83,30.19V25.01a2.106,2.106,0,0,0,2.11-2.09v-.43h5.18v.43A7.287,7.287,0,0,1,26.83,30.19Z",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9813",
    "data-name": "Group 9813"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M26.83,30.19a7.287,7.287,0,0,1-7.29-7.27V11.11h5.18V22.92a2.106,2.106,0,0,0,2.11,2.09v5.18Z",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9814",
    "data-name": "Group 9814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M43.52,11.35H38.34v-.43a2.106,2.106,0,0,0-2.11-2.09V3.65a7.287,7.287,0,0,1,7.29,7.27Z",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9815",
    "data-name": "Group 9815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M34.12,22.74H28.94V10.92a7.287,7.287,0,0,1,7.29-7.27V8.83a2.106,2.106,0,0,0-2.11,2.09Z",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9816",
    "data-name": "Group 9816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M45.63,30.19V25.01a2.106,2.106,0,0,0,2.11-2.09v-.43h5.18v.43A7.287,7.287,0,0,1,45.63,30.19Z",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9817",
    "data-name": "Group 9817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M45.63,30.19a7.287,7.287,0,0,1-7.29-7.27V10.51h5.18V22.92a2.106,2.106,0,0,0,2.11,2.09Z",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9818",
    "data-name": "Group 9818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M62.32,23.14H57.14V10.92a2.106,2.106,0,0,0-2.11-2.09V3.65a7.287,7.287,0,0,1,7.29,7.27Z",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9819",
    "data-name": "Group 9819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M52.92,23.33H47.74V10.92a7.287,7.287,0,0,1,7.29-7.27V8.83a2.106,2.106,0,0,0-2.11,2.09Z",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9820",
    "data-name": "Group 9820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M64.43,30.4V25.22a2.106,2.106,0,0,0,2.11-2.09V22.7h5.18v.43A7.287,7.287,0,0,1,64.43,30.4Z",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9821",
    "data-name": "Group 9821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M64.43,30.4a7.287,7.287,0,0,1-7.29-7.27h5.18a2.106,2.106,0,0,0,2.11,2.09Z",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9822",
    "data-name": "Group 9822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M81.12,31.43H75.94V11.14a2.106,2.106,0,0,0-2.11-2.09V3.87a7.287,7.287,0,0,1,7.29,7.27Z",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9823",
    "data-name": "Group 9823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M71.72,23.55H66.54V11.14a7.287,7.287,0,0,1,7.29-7.27V9.05a2.106,2.106,0,0,0-2.11,2.09Z",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9824",
    "data-name": "Group 9824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M24.72,11.35H19.54v-.43a2.106,2.106,0,0,0-2.11-2.09V3.65a7.287,7.287,0,0,1,7.29,7.27v.43Z",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9825",
    "data-name": "Group 9825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M15.32,31.1H10.14V10.92a7.287,7.287,0,0,1,7.29-7.27V8.83a2.106,2.106,0,0,0-2.11,2.09V31.1Z",
    fill: "#6a7084"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondenserOffHeaterOff);
export default __webpack_public_path__ + "static/media/condenser_off_heater_off.d991f51abcfcbc9a8441a5be78ec8eef.svg";
export { ForwardRef as ReactComponent };